import { render } from "./EmployeeApprovalsNew.vue?vue&type=template&id=85f200ec"
import script from "./EmployeeApprovalsNew.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovalsNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__